module.exports = __webpack_public_path__ + "img/ICONO5.b356779b.png";